class AlertBanner {
  constructor(node) {
    this.rootElement = node;
    this.dismissButton = this.rootElement.querySelector('.c-alert__dismissable');
    this.body = this.rootElement.closest('body');
    this.siteHeader = this.body.querySelector('.o-site-header');

    if (this.dismissButton) {
      this.dismissButton.addEventListener('click', this.dismissAlert.bind(this));
    }

    if (this.rootElement.classList.contains('c-alert--global')) {
      const alertHeight = this.rootElement.clientHeight;
      this.siteHeader.style.marginTop = `${alertHeight}px`;
    }
  }

  dismissAlert() {

    if (this.rootElement) {
      this.rootElement.remove();
    }

    if (this.rootElement.classList.contains('c-alert--global') && this.siteHeader.marginTop !== 0) {
      this.siteHeader.style.marginTop = '0';
    }
  }
}

const alertBanners = document.querySelectorAll('.c-alert');
alertBanners.forEach((alertBanner) => {
  new AlertBanner(alertBanner);
});
